import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './FAQSection.css'; 

const faqData = [
  {
    id: 1,
    question: '¿Cómo puedo empezar un proyecto con ustedes?',
    answer: 'El primer paso es agendar una consulta inicial a través de nuestra sección de contacto. Analizaremos tus objetivos para trazar una hoja de ruta técnica a la medida.',
  },
  {
    id: 2,
    question: '¿Cuánto tiempo tardan en completar un proyecto?',
    answer: 'Depende de la complejidad. Un MVP suele tomar de 4 a 8 semanas, mientras que sistemas ERP o industriales se planifican por fases mediante metodologías ágiles.',
  },
  {
    id: 3,
    question: '¿Cuáles son sus tarifas?',
    answer: 'Nuestros presupuestos se basan en el stack tecnológico y las horas de ingeniería requeridas. Tras la consulta inicial, recibirás una propuesta técnica y económica detallada.',
  },
];

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`faq-item-wrapper ${isOpen ? 'active' : ''}`}>
      <button className="faq-question-btn" onClick={() => setIsOpen(!isOpen)}>
        <span>{question}</span>
        <FontAwesomeIcon 
          icon={faChevronDown} 
          className={`faq-chevron ${isOpen ? 'rotated' : ''}`} 
        />
      </button>
      
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="faq-answer-container"
          >
            <p className="faq-answer-text">{answer}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQSection = () => {
  return (
    <section id="preguntas" className="faq-section">
      <div className="faq-glow-bg"></div>
      
      <motion.h2 
        className="faq-title"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        Preguntas Frecuentes
      </motion.h2>

      <div className="faq-list-container">
        {faqData.map((item) => (
          <FAQItem
            key={item.id}
            question={item.question}
            answer={item.answer}
          />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;